import { Link } from "react-router-dom";
import Loading from "../../Loading";

export default function SubmitAction({ isLoading, submit, href, hrefText }) {
  const signAction = () => {
    if (isLoading) {
      return <Loading />;
    } else {
      return (
        <>
          <span className="hell">or</span>
          <Link to={href} className="login-register hell">
            {hrefText}
          </Link>
        </>
      );
    }
  };
  return (
    <div className="d-flex align-items-center justify-content-between">
      <button type="submit" disabled={isLoading}>
        {!submit ? "submit" : submit}
      </button>
      {signAction()}
    </div>
  );
}
